/**
 * ServiceAlert API Documentation
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const PageNames = {
    SubscriptionModule: 'SubscriptionModule',
    SubscriptionStdReceiver: 'SubscriptionStdReceiver',
    FakeRequestAndSavePinCode: 'FakeRequestAndSavePinCode',
    EnrollmentModule: 'EnrollmentModule',
    SupportPage: 'SupportPage'
} as const;
export type PageNames = typeof PageNames[keyof typeof PageNames];

